import React, { useEffect, useState } from "react";
import { Arrow, Calendar, Container, InputContainer, MonthHeader, MonthTile, MonthsDiv, } from "./styles";
import { addYears, eachMonthOfInterval, endOfMonth, endOfYear, isBefore, startOfMonth, startOfYear, subYears, } from "date-fns";
import { TiArrowSortedDown } from "react-icons/ti";
import { months } from "../../../utils/constants";
import { hexToRgb } from "../../../utils/functions";
export var MonthCalendar = function (_a) {
    var onDateSelected = _a.onDateSelected, _b = _a.calendarColor, calendarColor = _b === void 0 ? "#ff2c3a" : _b, minDate = _a.minDate, maxDate = _a.maxDate;
    var now = new Date();
    var hoverCustomColor = hexToRgb(calendarColor).hover;
    var _c = useState(false), showCalendar = _c[0], setShowCalendar = _c[1];
    var _d = useState(eachMonthOfInterval({ start: startOfYear(now), end: endOfYear(now) })), monthsOfYear = _d[0], setMonthsOfYear = _d[1];
    var _e = useState(new Date()), monthSelected = _e[0], setMonthSelected = _e[1];
    useEffect(function () {
        setMonthsOfYear(eachMonthOfInterval({
            start: startOfYear(monthSelected),
            end: endOfYear(monthSelected)
        }));
        if (onDateSelected) {
            onDateSelected({
                start: startOfMonth(monthSelected),
                end: endOfMonth(monthSelected)
            });
        }
    }, [monthSelected]);
    useEffect(function () {
        window.addEventListener("click", function () {
            setShowCalendar(false);
        });
    }, []);
    return (React.createElement(Container, { onClick: function (e) { return e.stopPropagation(); } },
        React.createElement(InputContainer, { calendarColor: calendarColor, onClick: function () { return setShowCalendar(!showCalendar); } },
            React.createElement("input", { readOnly: true, value: "".concat(months[monthSelected.getMonth()], " de ").concat(monthSelected.getFullYear()) }),
            React.createElement(TiArrowSortedDown, { color: calendarColor, size: 25 })),
        React.createElement(Calendar, { show: showCalendar },
            React.createElement(Arrow, null),
            React.createElement(MonthHeader, { calendarColor: calendarColor },
                React.createElement(TiArrowSortedDown, { onClick: function () { return setMonthSelected(subYears(monthSelected, 1)); }, color: calendarColor, size: 25, style: {
                        transform: "rotate(90deg)"
                    } }),
                React.createElement("span", null, monthSelected.getFullYear()),
                React.createElement(TiArrowSortedDown, { onClick: function () { return setMonthSelected(addYears(monthSelected, 1)); }, color: calendarColor, size: 25, style: {
                        transform: "rotate(-90deg)"
                    } })),
            React.createElement(MonthsDiv, null, monthsOfYear.map(function (month, i) {
                var isMinDate = minDate && isBefore(month, minDate);
                var isMaxDate = maxDate && isBefore(maxDate, month);
                var disabled = isMinDate || isMaxDate;
                console.log("month", month);
                return (React.createElement(MonthTile, { calendarColor: calendarColor, hoverColor: hoverCustomColor, key: i, onClick: function () {
                        if (disabled)
                            return;
                        setMonthSelected(month);
                        setShowCalendar(false);
                    }, disabled: disabled, isSelected: month.getMonth() === monthSelected.getMonth() }, months[month.getMonth()].substring(0, 3)));
            })))));
};
//# sourceMappingURL=index.js.map